import React from "react";
import { Form, Formik } from "formik";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import FormikInput from "components/form/formik-input";
import FormikTextarea from "components/form/formik-textarea";

export default function CreateEditThemeDialog({
    open,
    onClose,
    onSubmit,
    themeEdit,
    validationSchema,
}) {
    return (
        <Dialog open={open} handler={onClose} className="dialog">
            <DialogHeader className="dialog__header">
                Create/Edit Theme
            </DialogHeader>
            <Formik
                initialValues={{
                    name: themeEdit?.name || "",
                    description: themeEdit?.description || "",
                }}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
                enableReinitialize
            >
                {({ isValid, dirty }) => (
                    <Form>
                        <DialogBody className="dialog__body">
                            <div className="mb-4 p-2 bg-bb font-body bg-white rounded-xl">
                                <FormikInput
                                    className="font-body"
                                    name="name"
                                    type="text"
                                    label="Theme Name"
                                    required
                                />
                            </div>
                            <div className="p-2 bg-bb font-body bg-white rounded-xl">
                                <FormikTextarea
                                    color="blue-gray"
                                    name="description"
                                    className="text-lg font-body text-primary-text"
                                    label="Theme Description (Optional)"
                                />
                            </div>
                        </DialogBody>
                        <DialogFooter className="dialog__footer">
                            <Button
                                type="button"
                                className="btn btn--secondary"
                                variant="filled"
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                disabled={
                                    !(isValid && (dirty || !themeEdit?.id))
                                }
                                className="btn btn--primary"
                                variant="filled"
                            >
                                Save
                            </Button>
                        </DialogFooter>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
